import RoutePath from '../../../../../constants/routePath';

export class ObservationsRouterHelper {
  
  static OBSERVATION_DETAILS_PATH = RoutePath.ROUTE_2BAP_OBSERVATION_DETAILS;
  static OBSERVATION_IDENTIFIER = 'id';
  
}
